<template>
  <content-div>

    <step-bar step="1" title="BMW ServiceCare+ 약관"></step-bar>
    
    <div class="contArea tpd">
      <term-service-view 
        :terms="terms"
        :adTerms="adTerms"
      ></term-service-view>

      <button-apply before="/" @submit="validate"></button-apply>
    </div>

    <popup-alert v-if="activate" :title="popupTitle" :btn_cancel="info" @close="closePopup">
      <popup-msg :type="popupMsg"></popup-msg>
    </popup-alert>

  </content-div>
</template>


<script>
  import ConstTerms from "../../../helpers/ConstTerms";

  import SubscApplyTermConst from "./SubscApplyTermConst";

  import StepBar from "@/components/StepBar.vue";
  import TermServiceView from "@/views/Term/TermServiceView";
  import ButtonApply from "@/components/Button/ButtonSubscApply.vue";

  import PopupAlert from '@/components/Popup/PopupAlert.vue';
  import PopupMsg from "@/components/Popup/PopupMsgTemplate";

  
  
  export default {
    
    beforeRouteEnter(to, from, next) {
      // if (
      //   from.name != 'SubscGuide' &&         // 서비스가이드
      //   from.name != 'SubscApplyVehicleReg'  // 구독 차량등록증 촬영
      // ) {
      //   alert('잘못된 접근경로 입니다.');
      //   this.$store.commit("unsetTerms");
      //   next('/')
      // } else {
        next();
      // }
    },
    
    beforeRouteLeave(to, from, next) {
      const nextView = 'SubscApplyPkg';
      //'SubscApplyVehicleReg' 간소화 이전 화면
      if (to.name != nextView) {
        this.$store.commit("unsetTerm");   // 서비스 신청 절차 상 다음화면으로 이동하는게 아니면 약관체크 모두 해제
        this.$store.commit("unsetTermRecevie");  
      }
      next();
    },

    components: { 
      StepBar,
      TermServiceView,
      ButtonApply,
      PopupAlert,
      PopupMsg,
    },

    watch: {
      termMarketingChecked(v) { this.changeTermMarketingChecked(v); },
      termAdReceiveChecked(v) { this.changeTermAdReceiveChecked(v); },
      adTermschecked(v) { this.changeAdTermschecked(v); },
    },

    computed: {
      termMarketingChecked(){
        let term = this.terms.find((t)=> t.key == ConstTerms.MARKETING);
        return (term) ? term.checked : false;
      },

      termAdReceiveChecked(){
        let term = this.terms.find((t)=> t.key == ConstTerms.AD_RECEIVE_AGREE);
        return (term) ? term.checked : false;
      },

      adTermschecked(){
        let term = this.adTerms.find((t)=> t.checked == true);
        return (term) ? term.checked : false;
      }
    },

    created() {
      window.scroll(0, 0);
      // 미등록 가입자 접근제한
      if (!this.chechUserVtg()) {
        this.popupMsg = 'NO_VTG_USER';
        this.popupTitle = '안내';
        this.activate = true;
        this.info = false;
        return;
      }

      // vue 생성 시 필수체크 항목이 체크되어있다 = 이전 페이지에서 넘어온 것으로 간주, 알림창 비활성 처리
      const storeTerms = this.$store.state.term;
      if (storeTerms) this.terms.forEach((term) => { term.checked = storeTerms[term.key]; });
    },

    data() {
      return {
        activate: false,
        info: true,
        popupMsg: 'SUBSC_INFO',
        popupTitle: '',
        selected: [],
        terms: SubscApplyTermConst.TERMS,
        adTerms: SubscApplyTermConst.TERMS_AD_RECEIVE,
      };
    },

    methods: {

      closePopup(submit) {
        this.activate = false;
        // 서비스신청 준비에서 취소 클릭 시 이전페이지로
        if (!submit && this.info) {
          this.$router.go(-1);
        } else if (this.popupMsg == 'NO_VTG_USER') {
          this.$router.go(-1);
        }
      },

      set() {

        //this.$store.commit('setBtnLoading', true);

        let terms = {}
        let adTerms = {}

        this.terms.forEach(term => { terms[term.key] = term.checked; });
        this.adTerms.forEach(adTerm => { adTerms[adTerm.key] = adTerm.checked; });

        this.$store.commit("setTerm", terms);
        this.$store.commit("setTerm", adTerms);

        this.$router.push(`/subscApply/pkg?pkg=${this.$route.query.pkg}&date=${this.$route.query.date}&vehicle=${this.$route.query.vehicle}&term=${this.$route.query.term}&step=2`);

        this.$store.state.vehicle.km = '';
        this.$store.state.att.vehicle.panel.path = '';
      },

      validate() {
        for (let i in this.terms) {
          if (!(this.terms[i].checked || !this.terms[i].required)) {
            this.popupMsg = 'NEED_SUBSC_TERM_CHECK'
            this.popupTitle = '안내';
            this.activate = true;
            this.info = false;
            return;
          }
        }

        if(this.termAdReceiveChecked) {
          let adReceive = this.adTerms.filter((adt)=>{ return adt.checked })
          if(adReceive.length == 0){
            this.popupMsg = 'NEED_SUBSC_TERM_RECEIVE_CHECK'
            this.popupTitle = '안내';
            this.activate = true;
            this.info = false;
            return;
          }
        }

        this.set();
      },

      changeTermMarketingChecked(v) {
        if(!v) {
          let term = this.terms.find((t)=> t.key == ConstTerms.AD_RECEIVE_AGREE);
          if(term) term.checked = false;
        }
      },

      changeTermAdReceiveChecked(v){
        if(v) {
          
          let term = this.terms.find((t)=> t.key == ConstTerms.MARKETING);
          if(term) term.checked = true;

          if(!this.adTermschecked)
            this.adTerms.forEach(adTerm => { adTerm.checked = true; });

        } else {
          this.adTerms.forEach(adTerm => { adTerm.checked = false; });
        }
      },

      changeAdTermschecked(v){
        if(v) {
          let term = this.terms.find((t)=> t.key == ConstTerms.AD_RECEIVE_AGREE);
          if(term) term.checked = true;
        } 
      }



    },
  };
</script>

